export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";